module.exports = __webpack_public_path__ + "static/media/whiteHeartMob.d4855c9c.svg";